// @ts-nocheck
(function () {
  'use strict';

  function initCardSwap() {
    var wraps = document.querySelectorAll('.fn-pcard-img[data-card-id]');

    wraps.forEach(function (wrap) {
      var cardId = wrap.getAttribute('data-card-id');
      var mainImg = wrap.querySelector('.fn-pcard-main');
      if (!mainImg) return;

      var thumbsEl = document.querySelector('.fn-card-thumbs[data-card-id="' + cardId + '"]');
      var thumbBtns = thumbsEl ? Array.from(thumbsEl.querySelectorAll('.fn-card-thumb-btn')) : [];

      var raw = wrap.getAttribute('data-images') || '';
      var allImages = raw ? raw.split('||').filter(Boolean) : [];
      if (!allImages.length) {
        var orig = mainImg.getAttribute('data-original-src') || mainImg.getAttribute('src') || '';
        if (orig) allImages = [orig];
      }

      var defaultSrc = allImages[0] || '';
      var arrowIndex = 0;
      var fadeTimer = null;
      var resetTimer = null;
      var slideTimer = null;
      var isSliding = false;
      var outgoingEl = null; // tracks any live cross-fade overlay

      // ── cross-fade: no white flash ─────────────────────────────────────────
      // Snapshots the current image as an overlay, swaps the src underneath,
      // then fades the overlay out. At every moment an image is fully visible.

      function fade(src) {
        if (isSliding) return;
        clearTimeout(fadeTimer);

        // Remove any previous cross-fade overlay that hasn't finished
        if (outgoingEl && wrap.contains(outgoingEl)) {
          wrap.removeChild(outgoingEl);
          outgoingEl = null;
        }

        // Snapshot current image as a positioned overlay
        var outgoing = document.createElement('img');
        outgoing.src = mainImg.src;
        outgoing.style.position = 'absolute';
        outgoing.style.top = '0';
        outgoing.style.left = '0';
        outgoing.style.right = '0';
        outgoing.style.bottom = '0';
        outgoing.style.width = '100%';
        outgoing.style.height = '100%';
        outgoing.style.objectFit = 'cover';
        outgoing.style.display = 'block';
        outgoing.style.margin = '0';
        outgoing.style.opacity = '1';
        outgoing.style.transition = 'none';
        // Insert before arrows so arrows remain on top
        var prevBtn = wrap.querySelector('.fn-arrow--prev');
        wrap.insertBefore(outgoing, prevBtn || null);
        outgoingEl = outgoing;

        // Immediately swap the new src underneath the overlay (invisible)
        mainImg.src = src;
        mainImg.style.opacity = '1';

        // Force reflow, then fade the overlay out, revealing the new image
        void outgoing.offsetWidth;
        outgoing.style.transition = 'opacity 0.3s ease';
        outgoing.style.opacity = '0';

        fadeTimer = setTimeout(function () {
          if (wrap.contains(outgoing)) wrap.removeChild(outgoing);
          if (outgoingEl === outgoing) outgoingEl = null;
        }, 320);
      }

      // ── instant swap (hover preview on main image — no animation) ──────────
      // Avoids any in-flight opacity animation conflicting with arrow slides.

      function swapNow(src) {
        if (isSliding) return;
        clearTimeout(fadeTimer);
        if (outgoingEl && wrap.contains(outgoingEl)) {
          wrap.removeChild(outgoingEl);
          outgoingEl = null;
        }
        mainImg.style.opacity = '1';
        mainImg.src = src;
      }

      // ── slide: horizontal carousel for arrow clicks ────────────────────────

      function slideImage(direction, nextSrc) {
        if (isSliding) return;
        isSliding = true;
        clearTimeout(fadeTimer);
        clearTimeout(slideTimer);

        // Clean up any cross-fade overlay before sliding
        if (outgoingEl && wrap.contains(outgoingEl)) {
          wrap.removeChild(outgoingEl);
          outgoingEl = null;
        }

        mainImg.style.opacity = '1';
        mainImg.style.transition = 'none';
        mainImg.style.transform = 'translateX(0)';
        mainImg.style.position = 'absolute';
        mainImg.style.top = '0';
        mainImg.style.left = '0';
        mainImg.style.right = '0';
        mainImg.style.bottom = '0';
        mainImg.style.width = '100%';
        mainImg.style.height = '100%';

        var incoming = document.createElement('img');
        incoming.src = nextSrc;
        incoming.style.position = 'absolute';
        incoming.style.top = '0';
        incoming.style.left = '0';
        incoming.style.right = '0';
        incoming.style.bottom = '0';
        incoming.style.width = '100%';
        incoming.style.height = '100%';
        incoming.style.objectFit = 'cover';
        incoming.style.display = 'block';
        incoming.style.margin = '0';
        incoming.style.opacity = '1';
        incoming.style.transition = 'none';
        incoming.style.transform = direction === 'next' ? 'translateX(100%)' : 'translateX(-100%)';

        var prevBtn = wrap.querySelector('.fn-arrow--prev');
        wrap.insertBefore(incoming, prevBtn || null);

        void wrap.offsetWidth;

        var ease = 'transform 320ms cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        incoming.style.transition = ease;
        incoming.style.transform = 'translateX(0)';
        mainImg.style.transition = ease;
        mainImg.style.transform = direction === 'next' ? 'translateX(-100%)' : 'translateX(100%)';

        slideTimer = setTimeout(function () {
          mainImg.style.transition = 'none';
          mainImg.style.transform = 'none';
          mainImg.src = nextSrc;
          mainImg.style.position = '';
          mainImg.style.top = '';
          mainImg.style.left = '';
          mainImg.style.right = '';
          mainImg.style.bottom = '';
          mainImg.style.width = '';
          mainImg.style.height = '';
          mainImg.style.margin = '';
          mainImg.style.opacity = '1';
          if (wrap.contains(incoming)) wrap.removeChild(incoming);
          requestAnimationFrame(function () {
            mainImg.style.transition = '';
            mainImg.style.transform = '';
            isSliding = false;
          });
        }, 330);
      }

      // ── helpers ────────────────────────────────────────────────────────────

      function setActive(src) {
        thumbBtns.forEach(function (btn) {
          btn.classList.toggle('fn-active', btn.getAttribute('data-img-src') === src);
        });
      }

      function resetToDefault() {
        if (isSliding) return;
        arrowIndex = 0;
        fade(defaultSrc);
        setActive(defaultSrc);
      }

      function scheduleReset() {
        clearTimeout(resetTimer);
        resetTimer = setTimeout(resetToDefault, 250);
      }

      function cancelReset() {
        clearTimeout(resetTimer);
      }

      // ── initialise ─────────────────────────────────────────────────────────
      setActive(defaultSrc);

      // ── main image hover ───────────────────────────────────────────────────

      wrap.addEventListener('mouseenter', function () {
        cancelReset();
        if (allImages.length > 1 && arrowIndex === 0) {
        arrowIndex = 1;
        swapNow(allImages[1]);
        }
      });

      wrap.addEventListener('mouseleave', function () {
        scheduleReset();
      });

      // ── thumbnail container ────────────────────────────────────────────────

      if (thumbsEl) {
        thumbsEl.addEventListener('mouseenter', cancelReset);
        thumbsEl.addEventListener('mouseleave', scheduleReset);
      }

      // ── thumbnail buttons ──────────────────────────────────────────────────

      thumbBtns.forEach(function (btn) {
        var src = btn.getAttribute('data-img-src');
        var alt = btn.getAttribute('data-img-alt');

        btn.addEventListener('mouseenter', function () {
          cancelReset();
          fade(src);
          setActive(src);
        });

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          fade(src);
          setActive(src);
        });

        btn.addEventListener('focus', function () {
          cancelReset();
          fade(src);
          setActive(src);
        });

        btn.addEventListener('blur', scheduleReset);
      });

      // ── arrows ─────────────────────────────────────────────────────────────

      var prevBtn = wrap.querySelector('.fn-arrow--prev');
      var nextBtn = wrap.querySelector('.fn-arrow--next');

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var nextIndex = (arrowIndex + 1) % allImages.length;
          slideImage('next', allImages[nextIndex]);
          arrowIndex = nextIndex;
          setActive(allImages[arrowIndex]);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var nextIndex = (arrowIndex - 1 + allImages.length) % allImages.length;
          slideImage('prev', allImages[nextIndex]);
          arrowIndex = nextIndex;
          setActive(allImages[arrowIndex]);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardSwap);
  } else {
    initCardSwap();
  }
})();
